<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 16.6667H4.33333C3.39991 16.6667 2.9332 16.6667 2.57668 16.485C2.26308 16.3252 2.00811 16.0703 1.84832 15.7567C1.66667 15.4001 1.66667 14.9334 1.66667 14V6C1.66667 5.06658 1.66667 4.59987 1.84832 4.24335C2.00811 3.92975 2.26308 3.67478 2.57668 3.51499C2.9332 3.33333 3.39991 3.33333 4.33333 3.33333H4.66667C6.53351 3.33333 7.46693 3.33333 8.17997 3.69664C8.80717 4.01622 9.31711 4.52616 9.63669 5.15336C10 5.8664 10 6.79982 10 8.66667M10 16.6667V8.66667M10 16.6667H15.6667C16.6001 16.6667 17.0668 16.6667 17.4233 16.485C17.7369 16.3252 17.9919 16.0703 18.1517 15.7567C18.3333 15.4001 18.3333 14.9334 18.3333 14V6C18.3333 5.06658 18.3333 4.59987 18.1517 4.24335C17.9919 3.92975 17.7369 3.67478 17.4233 3.51499C17.0668 3.33333 16.6001 3.33333 15.6667 3.33333H15.3333C13.4665 3.33333 12.5331 3.33333 11.82 3.69664C11.1928 4.01622 10.6829 4.52616 10.3633 5.15336C10 5.8664 10 6.79982 10 8.66667"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
